import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import api from "../lib/api";
import useSeo from "../hooks/useSeo";
import * as Icons from "lucide-react";
import { ChevronRight, ArrowRight } from "lucide-react";

const LucideIcon = ({ name, ...props }) => {
  const Ico = Icons[name] || Icons.Compass;
  return <Ico {...props} />;
};

export default function OpeningGuide() {
  const [steps, setSteps] = useState([]);
  useEffect(() => { api.get("/opening-guide").then((r) => setSteps(r.data || [])); }, []);
  useSeo({
    title: "Otel Açılış Rehberi — Otel Pro",
    description: "Otel açılışının 5 kritik adımı: Konsept, Mevzuat, Ekipman Seçimi, Kurulum, Açılış & Sürekli Tedarik.",
  });

  return (
    <Layout>
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">Açılış Rehberi</span>
        </div>
      </div>

      <section className="bg-navy text-white py-20" data-testid="guide-hero">
        <div className="container-site max-w-3xl">
          <p className="accent-script text-gold text-2xl mb-2">Uzman Rehber</p>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold leading-tight">
            Otel Açılış Rehberi
          </h1>
          <p className="text-white/75 mt-4 leading-relaxed">
            Konseptten açılışa — otel projenizin 5 kritik aşamasında size adım adım yol gösteriyoruz.
            Her adımda mevzuat, yıldız gereksinimleri ve ekipman tavsiyelerinizi uzman gözüyle sunuyoruz.
          </p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-site max-w-4xl">
          <div className="space-y-6">
            {steps.map((s, i) => (
              <Link
                key={s.id}
                to={`/acilis-rehberi/${s.slug}`}
                className="card-premium flex gap-5 p-6 md:p-7 items-start group"
                data-testid={`guide-row-${s.slug}`}
              >
                <div className="shrink-0 h-14 w-14 rounded-full bg-navy text-gold flex items-center justify-center group-hover:bg-gold group-hover:text-white transition-colors">
                  <LucideIcon name={s.icon} size={22} />
                </div>
                <div className="flex-1">
                  <p className="text-[11px] uppercase tracking-wider text-gold font-medium">Adım {i + 1}</p>
                  <h2 className="heading-serif text-xl md:text-2xl font-semibold text-navy mt-1 group-hover:text-gold transition-colors">
                    {s.title_tr}
                  </h2>
                  <p className="text-sm text-gray-600 mt-2">{s.summary}</p>
                </div>
                <ArrowRight size={18} className="text-gray-400 group-hover:text-gold mt-4 shrink-0" />
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
